import React from "react";
import { Loader2 } from "lucide-react";
import { ScoutLoopMark } from "../brand/ScoutLoopMark";

export const LoadingScreen: React.FC = () => {
  return (
    <div className="h-screen w-full flex flex-col items-center justify-center bg-slate-950 p-8 text-center">
      <div className="relative mb-12">
        <Loader2 className="animate-spin text-amber-600" size={80} />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
          <ScoutLoopMark size={32} color="rgba(255,255,255,0.2)" />
        </div>
      </div>
      <h2 className="text-white font-black uppercase italic tracking-tighter text-2xl">
        Initializing Locker...
      </h2>
    </div>
  );
};
